import Axios from "axios";
import { Authentication } from "@/Kernel/Authentication";

let RefreshingPromise = null;

/**
 *
 * @type {AxiosInstance|null}
 */
let AppHttpResource = Axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});

/*
 * Add the Bearer token to each request.
 */
AppHttpResource.interceptors.request.use(config => {
  config.headers.Authorization = "Bearer " + Authentication.getAccessToken();

  /*
   * If the application is currently in the middle of refreshing a JWT token, pause
   * and run this request after the user has re-authenticated.
   */
  if (RefreshingPromise !== null) {
    RefreshingPromise.then(() => {
      return config;
    });
  } else {
    return config;
  }
});
AppHttpResource.defaults.withCredentials = true;
AppHttpResource.interceptors.response.use(
  res => {
    /*
     * Log an analytics event signifying that this request has succeed
     */
    return Promise.resolve(res);
  },

  /*
   * Log an analytics event signifying that this has failed
   */
  err => {
    if (!err.response.hasOwnProperty("status")) {
      // Debugger.warn(`AppHttpResource: No Connection to server found.`);
    }

    // If the error is a 401, then do this
    if (err.response.status === 401 && err.response.code !== "ECONNABORTED") {
      /* Debugger.warn(
        `AppHttpResource: Unauthorized Header intercepted  [${err.config.url}]`
      );
      */

      // Create a New promise to wrap the response
      return new Promise((resolve, reject) => {
        // If we have a response promise, then add this to the que.
        if (RefreshingPromise !== null) {
          RefreshingPromise.then(() => {
            AppHttpResource.request(err.config)
              .then(res => {
                resolve(res);
              })
              .catch(err => {
                reject(err);
              });
          }).catch(err => {
            reject(err);
          });
        } else {
          // If we dont have a response promise, create one and add this to the que
          RefreshingPromise = Authentication.refreshAccessToken();
          RefreshingPromise.then(() => {
            AppHttpResource.request(err.config)
              .then(res => {
                resolve(res);
              })
              .catch(err => {
                reject(err);
              });
          });
          RefreshingPromise.catch(() => {
            reject(err);
          });
          RefreshingPromise.finally(() => {
            RefreshingPromise = null;
          });
        }
      });
    }
    return Promise.reject(err);
  }
);
export default AppHttpResource;
